/* ama-card-hover.js
   Hover a zone per le card con 2 foto: meta' sinistra = 1a foto,
   meta' destra = 2a foto (.product-card__secondary), piu' 2 puntini.
   Card con 1 foto: nessun effetto (restano con lo zoom via CSS). */
(function () {
  'use strict';
  function initCard(media) {
    if (media.__amaZone) return;
    var secondary = media.querySelector('.product-card__secondary');
    if (!secondary) return;
    media.__amaZone = true;

    var dots = document.createElement('div');
    dots.className = 'ama-dots';
    dots.innerHTML = '<span class="ama-dot is-active"></span><span class="ama-dot"></span>';
    media.appendChild(dots);
    var d0 = dots.children[0], d1 = dots.children[1];

    function show(right) {
      if (right) {
        secondary.classList.add('ama-show');
        d1.classList.add('is-active'); d0.classList.remove('is-active');
      } else {
        secondary.classList.remove('ama-show');
        d0.classList.add('is-active'); d1.classList.remove('is-active');
      }
    }
    media.addEventListener('mousemove', function (e) {
      var r = media.getBoundingClientRect();
      show((e.clientX - r.left) >= r.width / 2);
    });
    media.addEventListener('mouseleave', function () { show(false); });
  }
  function init() {
    var list = document.querySelectorAll('.product-card__media');
    for (var i = 0; i < list.length; i++) initCard(list[i]);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  if (document.body) {
    var mo = new MutationObserver(function () { init(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
